declare namespace $ {

	export class $hyoo_mol_ttt extends $mol_view {
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=ttt.view.tree.d.ts.map